import { gql } from "@apollo/client"

const SELECTION_JOB_STEP_FIELDS = gql`
  fragment SelectionJobStepFields on SelectionJobStep {
    id
    step
    number
    section
    name
    description
    responseType
    responseMandatory
    response
    compactResponseSelections {
      ...CompactResponseSelectionFields
    }
    responseCustomSelections
    responseBatch {
      ... on FoodItemBatch {
        id
        code
      }
    }
    skip
    notApplicable
    unresolvedActions
    hasResolvedActions
    completed @client
    completedAt
    completedBy {
      ...JobStepCompletedByFields
    }
    uploads {
      ...JobStepUploadsFields
    }
    selection {
      selectFrom
      allowMultiple
      enableBatchEntry
      customItems
    }
    logic {
      range
      textValues
      outcomes {
        type
        steps
      }
    }
    notes {
      ...JobStepNotesFields
    }
    repeatable
  }
`

export { SELECTION_JOB_STEP_FIELDS }
